







































































import { Component, Vue } from 'vue-property-decorator';
import { DataTableHeader } from 'vuetify';
import { refsService } from '@/app/shared/refs.service';
import { TicketModel, InteractionModel } from '@/app/shared/models';
@Component
export default class DataTabeProtocolsComponent extends Vue {
  private headers: DataTableHeader[] = [];
  private loading = true;

  private get refs() {
    return refsService;
  }
  private get ticketList(): TicketModel[] {
    return this.refs.modules.ticket.ticketList;
  }
  private get interactionList(): InteractionModel[] {
    return this.refs.modules.ticket.interactionList;
  }

  private created(): void {
    this.headers = [
      { text: this.$t('headers.protocol_no').toString(), value: 'Protocol' },
      {
        text: this.$t('headers.start').toString(),
        value: 'Created',
        sortable: false,
      },
      {
        text: this.$t('headers.end').toString(),
        value: 'Finish',
        sortable: false,
      },
      { text: this.$t('headers.user').toString(), value: 'User.Name' },
      { text: this.$t('headers.comments').toString(), value: 'Subject' },
      { text: '', value: 'data-table-expand', sortable: false },
    ];
  }

  private async loadInteractionList(dataItem: {
    item: TicketModel;
    value: boolean;
  }) {
    if (dataItem.value) {
      this.loading = true;
      await this.refs.modules.ticket
        .loadInteractionList(dataItem.item.Id)
        .catch((err) => this.$toast.error('ERROR ? ', err))
        .finally(() => (this.loading = false));
    }
  }
}
